module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nghd-list"
  }, [_c('h4', [_vm._v("Particularly, this neighborhood:\n    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentNghd),
      expression: "currentNghd"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentNghd = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selectName]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select a Neighborhood")]), _vm._v(" "), _vm._l((_vm.nghdNames), function(nghd) {
    return _c('option', {
      domProps: {
        "value": nghd
      }
    }, [_vm._v(_vm._s(nghd))])
  })], 2)]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "similarNghds"
    }
  }, [_vm._v("\n  Similar to " + _vm._s(_vm.compareNghd) + ":\n    "), _vm._l((_vm.nghdComparisons), function(nghd) {
    return _c('span', {
      staticClass: "compareNghdName"
    }, [_c('a', {
      staticClass: "selectNghdLink",
      on: {
        "click": function($event) {
          return _vm.selectNameText(nghd['name'])
        }
      }
    }, [_vm._v("\n        " + _vm._s(nghd['name']) + " " + _vm._s(nghd['average']) + "%\n      ")]), _vm._v(" "), _c('a', {
      staticClass: "whyLink",
      on: {
        "click": function($event) {
          return _vm.displayWhy(nghd['name'])
        }
      }
    }, [_vm._v("why?")])])
  })], 2), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nghdExplainedName !== ''),
      expression: "nghdExplainedName !== ''"
    }],
    attrs: {
      "id": "whyExplainer"
    }
  }, [_vm._v("\n    Similarity between " + _vm._s(_vm.compareNghd) + " and " + _vm._s(_vm.nghdExplainedName) + ":\n    "), _c('a', {
    staticClass: "hideLink",
    on: {
      "click": function($event) {
        return _vm.displayWhy('')
      }
    }
  }, [_vm._v("(hide)")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("What people say on Twitter: " + _vm._s(_vm.nghdExplanation['twitter']) + "%")]), _vm._v(" "), _c('li', [_vm._v("What people take photos of on Flickr: " + _vm._s(_vm.nghdExplanation['flickr']) + "%")]), _vm._v(" "), _c('li', [_vm._v("Venues on Foursquare: " + _vm._s(_vm.nghdExplanation['foursquare']) + "%")]), _vm._v(" "), _c('li', [_vm._v("Crime data: " + _vm._s(_vm.nghdExplanation['crime']) + "%")]), _vm._v(" "), _c('li', [_vm._v("Walkscores: " + _vm._s(_vm.nghdExplanation['walkscore']) + "%")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-05edd78b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NghdList.vue
// module id = 170
// module chunks = 1